'use strict';

var dialog = require('../../dialog'),
	util = require('../../util'),
	validator = require('../../validator'),
	linchpin = require('int_googletagmanager/linchpin/product');

/**
 * @function
 * @description Adds email to ProductBackInStockNotificationRequests custom object
 * @param {String} email cusomer's email
 * @param {String} productID product ID
 */
var submitEmailToNotify = function (email, productID, response) {
	// Prepare parameters
	var params = {
		format: 'ajax',
		email: email,
		productID: productID,
		'g-recaptcha-response': response
	};
	var url = util.appendParamsToUrl(Urls.backInStockSubmission, params);
	var options = {
		url: url,
		type: 'POST'
	};
	$.ajax(options).done(function () {
		$('#back-in-stock').html('<p>' + Resources.EMAIL_IS_SAVED + '</p>');
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.triggerNotifyWhenInStockEvent();
		}
	});
};

/**
 * @function
 * @description handle back in stock form submit
 * @param {String} response if submitted with recaptcha
 */
var submitHandler = function (response) {
	var email = $('#back-in-stock').find('input[name$="_email"]').first().val();
	var productID = $('#back-in-stock').find('input[name="productID"]').first().val();
	submitEmailToNotify(email, productID, response);
};

/**
 * @function
 * @description Binds the click event to the link
 *     (Notify me when this item is back in stock)
 */
var backInStock = function (e) {
	e.preventDefault();
	var url = $(this).attr('href');
	// add initialization captcha
	var reCaptcha = require('int_recaptcha/recaptcha');
	// Open dialog with email field
	dialog.open({
		url: url,
		options: {
			title: $(this).attr('title'),
			dialogClass: 'backinstock-dialog yes-and-no-dialog',
			open: function () {
				// if recaptcha disabled, init submission event
				if (!reCaptcha.initRecaptchaOnForm('#back-in-stock', submitHandler)) {
					$('#back-in-stock-submit').on('click', submitHandler);
				}
				var emailRegExp = validator.regex.email,
					emailInputField = $('input[name$="_email"]', '#back-in-stock');

				//validate email once value is checked
				$('input[name$="_email"]', '#back-in-stock').on('keyup', function () {
					if (emailRegExp.test($(this).val())) {
						$('#back-in-stock-submit').prop('disabled', false);
					} else {
						$('#back-in-stock-submit').prop('disabled', true);
					}
				});
				//disable submit if email is not pre-populated
				if (!emailInputField.val().trim()) {
					$('#back-in-stock-submit').prop('disabled', true);
				}
				// bind events for cancel and submit buttons
				$('#back-in-stock-cancel').on('click', function () {
					dialog.close();
				});
			}
		}
	});
};

module.exports = function () {
	$('.back-in-stock-msg').css('display', 'block');
	$('.product-set-list .back-in-stock-msg').css('display', 'none');
	$('.back-in-stock-notification').on('click', backInStock);
};
